export default __webpack_public_path__ + "static/media/weightlosswithfamily@2x.9c5843d1.jpg";